import { useSyncExternalStore } from "react";
import {
  getDisplayDateFormats,
  subscribeDisplaySettings,
} from "Shared/Utils/display";

/**
 * The company's display formats (date, dateTime, time) from Company
 * Settings, the same values displayDate()/formatDate() use. Components that
 * show dates call it so they re-render when the settings change.
 */
export const useDisplayFormats = () =>
  useSyncExternalStore(subscribeDisplaySettings, getDisplayDateFormats);
